import React from 'react';

const Footer = () => {
  return (
    <div className='py-4 text-center bg-secondary text-secondary' id='footer'>
      &copy; 2023 Patryk Fussek
    </div>
  );
};

export default Footer;
